<template>
  <div>
    <b-card class="mt-4">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-if="isLoaded">
        <b-overlay :show="busy" rounded="sm">
          <div class="row">
            <div class="col">
              <h3>Rodzaje produktów</h3>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-primary float-right"
                @click="AddItem"
              >
                <i class="fas fa-plus-circle fa-1x"></i> Dodaj produkt
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 font-weight-bold">ID</div>
            <div class="col-md-7 font-weight-bold">Nazwa</div>
            <div class="col-md-3 font-weight-bold">Akcje</div>
          </div>
          <div class="row p-1" v-for="item in items" :key="item.id">
            <div class="col-md-2">#{{ item.id }}</div>
            <div class="col-md-7">
              <input
                type="text"
                :disabled="!item.isEdit"
                class="form-control"
                v-model="item.name"
              />
            </div>
            <div class="col-md-3 div-icons-area">
              <span @click="SaveData(item)" v-if="item.isEdit"
                ><i class="fas fa-check fa-lg color-green"></i
              ></span>
              <span @click="ChangeEditStatus(item, false)" v-if="item.isEdit">
                <i class="fas fa-times fa-lg color-red"></i>
              </span>
              <span
                v-if="!item.isEdit"
                @click="ChangeEditStatus(item, true)"
                v-b-tooltip.hover
                title="Zmień nazwę"
              >
                <i class="fas fa-edit fa-lg"></i
              ></span>
              <span
                v-if="!item.isEdit"
                @click="RemoveItem(item)"
                v-b-tooltip.hover
                title="Usuń"
              >
                <i class="fas fa-trash fa-lg color-red"></i
              ></span>
            </div>
          </div>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import Loading from "../../Common/Loading";

export default {
  name: "VehicleAdministration",
  components: { Loading },
  mixins: [urlConfig, toastr],
  mounted() {
    this.Getitems();
  },
  data() {
    return {
      quesationText: "Czy napewno chcesz usunać produkt: ",
      newItemSuccess: "Nowy produkt został dodany: ",
      editItemSuccess: "Produkt został zedytowany.",
      busy: false,
      items: [],
      isLoaded: false,
    };
  },
  methods: {
    Getitems() {
      var url = this.url.serverUrl + this.url.RawMaterial.GetRawMaterialTypes;
      var that = this;
      axios
        .get(url)
        .then(function (response) {
          response.data.forEach(function (entry) {
            entry.isEdit = false;
          });
          that.items = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          console.log(e);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        });
    },
    AddItem() {
      this.items.unshift({ isEdit: true });
    },

    SaveData(item) {
      if (item.id) {
        this.UpdateItem(item);
      } else {
        this.SaveNewItem(item);
      }
    },

    SaveNewItem(item) {
      var url = this.url.serverUrl + this.url.RawMaterial.AddRawMaterialType;
      var that = this;
      this.busy = true;
      axios
        .post(url, { name: item.name })
        .then(function (response) {
          item.isEdit = false;
          item.id = response.data.id;
          that.DisplaySuccess("Sukces!", that.newItemSuccess + item.name);
          that.busy = false;
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
          that.DisplayError("Błąd!", e);
        });
    },

    ChangeEditStatus(item, status) {
      if (status == true) {
        item.oldName = item.name;
      } else {
        item.name = item.oldName;
        item.oldName = undefined;
        if (!item.id) {
          this.items = this.items.filter((x) => x.id != undefined);
        }
      }

      item.isEdit = status;
    },
    UpdateItem(item) {
      var url = this.url.serverUrl + this.url.RawMaterial.EditRawMaterialType;
      var that = this;
      this.busy = true;
      axios
        .post(url, { name: item.name, id: item.id })
        .then(function (response) {
          item.isEdit = false;
          item.id = response.data;
          that.DisplaySuccess("Sukces!", that.editItemSuccess);
          that.busy = false;
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
        });
    },
    RemoveItem(item) {
      if (confirm(this.quesationText + item.name)) {
        var that = this;
        var url = this.url.serverUrl + this.url.RawMaterial.DeleteRawMaterialType;
        this.busy = true;
        axios
          .post(url, { name: item.name, id: item.id })
          .then(function () {
            that.items = that.items.filter((x) => x.id != item.id);
            that.DisplaySuccess("Sukces!", "Produkt został usunięty.");
            that.busy = false;
          })
          .catch(function (e) {
            console.log(e);
            that.busy = false;
            that.DisplayError("Błąd!", e);
          });
      }
    },
  },
};
</script>